var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 806,
    height: 675,
    viewBox: "0 0 806 675",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M659.802 653.426L514.242 616.113H651.652L800.531 653.426H659.802Z",
    fill: "url(#paint0_linear_2162_7418)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.192 653.426L286.752 616.113H149.361L0.462891 653.426H141.192Z",
    fill: "url(#paint1_linear_2162_7418)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M407.215 498.204C407.215 498.204 407.077 497.517 406.861 496.24",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M406.211 492.391C404.11 478.782 400.555 444.827 413.89 429.666C430.798 410.479 451.065 426.916 507.545 429.666C564.025 432.415 593.09 424.187 593.679 375.758C594.269 327.33 561.139 324.129 561.139 324.129H540.204",
    stroke: "url(#paint2_linear_2162_7418)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "1.78 1.78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M538.22 324.207H536.256",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M536.256 175.446H538.22",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M542.148 175.446H612.847C612.847 175.446 634.154 177.292 633.271 201.88C632.387 226.467 596.94 249.503 599.198 298.599C601.456 347.695 685.234 340.37 696.644 389.525C708.054 438.68 624.237 436.225 616.441 461.598C613.99 467.286 612.785 473.433 612.906 479.626C612.906 487.874 612.906 507.473 612.906 515.859",
    stroke: "url(#paint3_linear_2162_7418)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "1.77 1.77"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M612.906 517.842V519.806",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.009 36.2885H274.045",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.137 36.2885H235.514C235.514 36.2885 141.25 35.2084 141.25 114.842C141.25 151.704 154.054 179.256 191.996 224.542C229.937 269.829 229.309 411.382 216.976 436.775C204.643 462.167 178.484 458.377 169.294 472.124C169.294 472.124 162.676 479.056 162.106 487.521C161.654 494.178 161.91 515.996 162.106 524.951",
    stroke: "url(#paint4_linear_2162_7418)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "1.76 1.76"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.008 527.013C162.008 528.251 162.008 528.977 162.008 528.977",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297.197 138.821C292.954 138.827 288.788 139.952 285.119 142.081C285.458 140.195 285.629 138.282 285.63 136.366C285.636 128.043 282.534 120.018 276.931 113.864C271.327 107.71 263.628 103.87 255.341 103.098C247.054 102.326 238.777 104.678 232.134 109.691C225.49 114.705 220.959 122.019 219.428 130.2C215.399 128.729 211.097 128.156 206.823 128.521C202.549 128.886 198.406 130.18 194.684 132.312C190.962 134.445 187.751 137.365 185.274 140.867C182.798 144.37 181.117 148.372 180.348 152.592C179.579 156.812 179.741 161.149 180.823 165.3C181.905 169.451 183.88 173.316 186.611 176.624C189.341 179.932 192.761 182.604 196.632 184.453C200.503 186.302 204.731 187.283 209.02 187.328H297.216C303.649 187.328 309.818 184.772 314.366 180.224C318.914 175.676 321.47 169.507 321.47 163.074C321.47 156.642 318.914 150.473 314.366 145.924C309.818 141.376 303.649 138.821 297.216 138.821H297.197Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M670.033 237.366C665.51 237.369 661.067 238.561 657.15 240.823C657.497 238.818 657.674 236.788 657.681 234.754C657.683 225.896 654.377 217.356 648.411 210.807C642.445 204.259 634.249 200.174 625.429 199.353C616.608 198.532 607.799 201.035 600.727 206.37C593.656 211.705 588.831 219.488 587.198 228.195C582.895 226.598 578.295 225.963 573.72 226.335C569.145 226.707 564.708 228.076 560.719 230.347C556.73 232.618 553.288 235.735 550.633 239.479C547.978 243.224 546.176 247.504 545.353 252.019C544.53 256.535 544.706 261.176 545.869 265.616C547.032 270.056 549.154 274.187 552.085 277.719C555.016 281.251 558.685 284.098 562.835 286.06C566.984 288.022 571.513 289.051 576.103 289.074H670.033C676.882 289.074 683.451 286.354 688.294 281.51C693.137 276.667 695.858 270.099 695.858 263.25C695.858 256.401 693.137 249.832 688.294 244.989C683.451 240.146 676.882 237.425 670.033 237.425V237.366Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M653.342 295.653H661.197",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M615.045 295.653H642.539",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M589.043 200.78C593.064 197.4 598.029 195.343 603.261 194.888",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M579.697 215.136C580.405 212.03 581.742 209.103 583.625 206.534",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M281.488 356.925C274.688 356.93 268.01 358.725 262.124 362.129C262.662 359.115 262.931 356.059 262.929 352.997C262.939 339.682 257.974 326.844 249.007 317.001C240.041 307.158 227.721 301.019 214.463 299.79C201.205 298.56 187.966 302.329 177.342 310.355C166.719 318.382 159.478 330.089 157.039 343.178C150.589 340.811 143.7 339.883 136.854 340.459C130.008 341.034 123.371 343.099 117.407 346.509C111.443 349.92 106.297 354.592 102.328 360.2C98.3599 365.808 95.6655 372.216 94.4337 378.975C93.2019 385.734 93.4626 392.68 95.1974 399.327C96.9323 405.975 100.099 412.163 104.477 417.457C108.854 422.752 114.337 427.026 120.539 429.98C126.742 432.933 133.516 434.495 140.385 434.556H281.488C291.626 434.328 301.272 430.14 308.361 422.889C315.451 415.639 319.42 405.901 319.42 395.76C319.42 385.619 315.451 375.882 308.361 368.631C301.272 361.38 291.626 357.192 281.488 356.964V356.925Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.154 430.608C106.13 431.92 108.197 433.088 110.34 434.104",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7363 412.502C90.6172 416.974 93.3522 421.036 96.7881 424.462",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175.793 296.635C183.95 291.022 193.733 288.261 203.621 288.78",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M167.291 304.491C168.66 302.702 170.213 301.063 171.926 299.601",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M536.256 164.586H526.928V189.252H536.256V164.586Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M536.256 310.087H526.928V334.753H536.256V310.087Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M285.334 21.8738H276.006V46.5396H285.334V21.8738Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M285.334 238.27H276.006V262.935H285.334V238.27Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M529.992 8.22509H284.453V61.406H529.992V8.22509Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M465.478 21.7952H296.254V47.8358H465.478V21.7952Z",
    fill: "url(#paint5_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M488.397 40.2357C492.02 40.2357 494.956 37.299 494.956 33.6765C494.956 30.0539 492.02 27.1172 488.397 27.1172C484.775 27.1172 481.838 30.0539 481.838 33.6765C481.838 37.299 484.775 40.2357 488.397 40.2357Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M520.663 33.6765C520.663 32.3792 520.279 31.111 519.558 30.0323C518.837 28.9537 517.813 28.113 516.614 27.6165C515.416 27.1201 514.097 26.9902 512.824 27.2433C511.552 27.4964 510.383 28.1211 509.466 29.0384C508.549 29.9557 507.924 31.1244 507.671 32.3968C507.418 33.6692 507.548 34.988 508.044 36.1866C508.541 37.3851 509.381 38.4095 510.46 39.1303C511.539 39.851 512.807 40.2357 514.104 40.2357C515.844 40.2357 517.512 39.5446 518.742 38.3145C519.972 37.0844 520.663 35.4161 520.663 33.6765Z",
    fill: "url(#paint6_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M450.122 40.2357C453.744 40.2357 456.681 37.299 456.681 33.6765C456.681 30.0539 453.744 27.1172 450.122 27.1172C446.499 27.1172 443.562 30.0539 443.562 33.6765C443.562 37.299 446.499 40.2357 450.122 40.2357Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M520.684 61.4059H293.781V79.6107H520.684V61.4059Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M529.992 79.6107H284.453V132.792H529.992V79.6107Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M465.478 93.1809H296.254V119.221H465.478V93.1809Z",
    fill: "url(#paint7_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M488.397 111.641C492.02 111.641 494.956 108.704 494.956 105.082C494.956 101.459 492.02 98.5226 488.397 98.5226C484.775 98.5226 481.838 101.459 481.838 105.082C481.838 108.704 484.775 111.641 488.397 111.641Z",
    fill: "url(#paint8_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M520.663 105.082C520.663 103.785 520.279 102.516 519.558 101.438C518.837 100.359 517.813 99.5183 516.614 99.0219C515.416 98.5254 514.097 98.3955 512.824 98.6486C511.552 98.9017 510.383 99.5264 509.466 100.444C508.549 101.361 507.924 102.53 507.671 103.802C507.418 105.075 507.548 106.393 508.044 107.592C508.541 108.79 509.381 109.815 510.46 110.536C511.539 111.256 512.807 111.641 514.104 111.641C514.966 111.644 515.82 111.476 516.617 111.147C517.414 110.818 518.138 110.335 518.748 109.726C519.358 109.116 519.841 108.392 520.169 107.595C520.498 106.798 520.666 105.944 520.663 105.082Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M450.122 111.641C453.744 111.641 456.681 108.704 456.681 105.082C456.681 101.459 453.744 98.5226 450.122 98.5226C446.499 98.5226 443.562 101.459 443.562 105.082C443.562 108.704 446.499 111.641 450.122 111.641Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M520.684 132.811H293.781V151.016H520.684V132.811Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M529.992 151.016H284.453V204.197H529.992V151.016Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M465.478 164.586H296.254V190.627H465.478V164.586Z",
    fill: "url(#paint9_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M488.397 183.027C492.02 183.027 494.956 180.09 494.956 176.468C494.956 172.845 492.02 169.908 488.397 169.908C484.775 169.908 481.838 172.845 481.838 176.468C481.838 180.09 484.775 183.027 488.397 183.027Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M520.663 176.468C520.663 175.17 520.279 173.902 519.558 172.823C518.837 171.745 517.813 170.904 516.614 170.408C515.416 169.911 514.097 169.781 512.824 170.034C511.552 170.287 510.383 170.912 509.466 171.829C508.549 172.747 507.924 173.916 507.671 175.188C507.418 176.46 507.548 177.779 508.044 178.978C508.541 180.176 509.381 181.201 510.46 181.921C511.539 182.642 512.807 183.027 514.104 183.027C515.844 183.027 517.512 182.336 518.742 181.106C519.972 179.876 520.663 178.207 520.663 176.468Z",
    fill: "url(#paint10_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M450.122 183.027C453.744 183.027 456.681 180.09 456.681 176.468C456.681 172.845 453.744 169.908 450.122 169.908C446.499 169.908 443.562 172.845 443.562 176.468C443.562 180.09 446.499 183.027 450.122 183.027Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M520.684 204.197H293.781V222.402H520.684V204.197Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M529.992 222.402H284.453V275.583H529.992V222.402Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M465.478 235.972H296.254V262.012H465.478V235.972Z",
    fill: "url(#paint11_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M488.397 254.432C492.02 254.432 494.956 251.495 494.956 247.873C494.956 244.25 492.02 241.314 488.397 241.314C484.775 241.314 481.838 244.25 481.838 247.873C481.838 251.495 484.775 254.432 488.397 254.432Z",
    fill: "url(#paint12_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M520.663 247.873C520.663 246.575 520.279 245.307 519.558 244.229C518.837 243.15 517.813 242.309 516.614 241.813C515.416 241.316 514.097 241.186 512.824 241.44C511.552 241.693 510.383 242.317 509.466 243.235C508.549 244.152 507.924 245.321 507.671 246.593C507.418 247.865 507.548 249.184 508.044 250.383C508.541 251.581 509.381 252.606 510.46 253.327C511.539 254.047 512.807 254.432 514.104 254.432C514.966 254.435 515.82 254.267 516.617 253.938C517.414 253.609 518.138 253.126 518.748 252.517C519.358 251.907 519.841 251.183 520.169 250.386C520.498 249.589 520.666 248.735 520.663 247.873Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M450.122 254.432C453.744 254.432 456.681 251.495 456.681 247.873C456.681 244.25 453.744 241.314 450.122 241.314C446.499 241.314 443.562 244.25 443.562 247.873C443.562 251.495 446.499 254.432 450.122 254.432Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M520.684 275.602H293.781V293.807H520.684V275.602Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M529.992 293.807H284.453V346.988H529.992V293.807Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M465.478 307.377H296.254V333.418H465.478V307.377Z",
    fill: "url(#paint13_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M488.397 325.818C492.02 325.818 494.956 322.881 494.956 319.259C494.956 315.636 492.02 312.699 488.397 312.699C484.775 312.699 481.838 315.636 481.838 319.259C481.838 322.881 484.775 325.818 488.397 325.818Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M520.663 319.259C520.663 317.961 520.279 316.693 519.558 315.614C518.837 314.536 517.813 313.695 516.614 313.199C515.416 312.702 514.097 312.572 512.824 312.825C511.552 313.078 510.383 313.703 509.466 314.62C508.549 315.538 507.924 316.707 507.671 317.979C507.418 319.251 507.548 320.57 508.044 321.769C508.541 322.967 509.381 323.992 510.46 324.712C511.539 325.433 512.807 325.818 514.104 325.818C515.844 325.818 517.512 325.127 518.742 323.897C519.972 322.667 520.663 320.998 520.663 319.259Z",
    fill: "url(#paint14_linear_2162_7418)",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M450.122 325.818C453.744 325.818 456.681 322.881 456.681 319.259C456.681 315.636 453.744 312.699 450.122 312.699C446.499 312.699 443.562 315.636 443.562 319.259C443.562 322.881 446.499 325.818 450.122 325.818Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M423.57 1.0767H437.317",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M328.324 1.0767H407.86",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M274.318 324.129V333.948",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M274.318 293.689V314.31",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M636.474 112.211L622.727 85.0114C622.65 84.8215 622.534 84.6495 622.388 84.5061C622.241 84.3628 622.066 84.2512 621.875 84.1782C621.683 84.1053 621.479 84.0727 621.274 84.0823C621.069 84.092 620.868 84.1437 620.684 84.2343C620.501 84.325 620.337 84.4525 620.205 84.609C620.072 84.7655 619.974 84.9476 619.915 85.1439C619.856 85.3403 619.838 85.5467 619.862 85.7503C619.886 85.9539 619.952 86.1502 620.056 86.3272L633.194 113.821C632.924 114.099 632.737 114.446 632.654 114.824C632.571 115.202 632.595 115.596 632.723 115.962L646.627 142.022C647 142.768 648.178 142.925 649.298 142.375C650.417 141.825 651.006 140.785 650.633 140.058L638.457 113.134C638.255 112.8 637.959 112.535 637.606 112.37C637.253 112.206 636.859 112.15 636.474 112.211Z",
    fill: "#21343E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M712.594 112.211L726.439 85.0115C726.609 84.6602 726.911 84.3905 727.279 84.2617C727.647 84.1328 728.051 84.1553 728.403 84.3241C728.747 84.5013 729.01 84.8037 729.138 85.169C729.266 85.5344 729.249 85.9348 729.09 86.288L715.932 113.782C716.208 114.056 716.396 114.405 716.473 114.786C716.55 115.168 716.512 115.563 716.364 115.922L702.46 141.983C702.087 142.729 700.889 142.886 699.79 142.336C698.69 141.786 698.081 140.745 698.435 140.019L710.63 113.094C710.836 112.772 711.131 112.516 711.48 112.359C711.829 112.202 712.216 112.151 712.594 112.211Z",
    fill: "#21343E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M717.856 143.2H631.506L637.987 132.203H711.375L717.856 143.2Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M717.836 143.2H631.506V154.198H717.836V143.2Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M673.179 151.134H639.99C639.347 151.129 638.733 150.87 638.281 150.414C637.828 149.958 637.574 149.341 637.574 148.699C637.574 148.058 637.829 147.444 638.282 146.991C638.735 146.538 639.349 146.283 639.99 146.283H673.179C673.819 146.283 674.434 146.538 674.887 146.991C675.34 147.444 675.594 148.058 675.594 148.699C675.594 149.341 675.34 149.958 674.888 150.414C674.436 150.87 673.821 151.129 673.179 151.134Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M693.269 150.525C694.441 150.525 695.39 149.576 695.39 148.404C695.39 147.233 694.441 146.283 693.269 146.283C692.098 146.283 691.148 147.233 691.148 148.404C691.148 149.576 692.098 150.525 693.269 150.525Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M704.189 148.404C704.189 147.981 704.064 147.567 703.829 147.215C703.593 146.863 703.259 146.589 702.868 146.427C702.477 146.265 702.046 146.222 701.631 146.305C701.216 146.387 700.835 146.591 700.535 146.891C700.236 147.19 700.032 147.571 699.949 147.987C699.867 148.402 699.909 148.832 700.071 149.223C700.233 149.615 700.508 149.949 700.86 150.184C701.212 150.419 701.625 150.545 702.049 150.545C702.331 150.548 702.61 150.494 702.871 150.387C703.132 150.281 703.369 150.123 703.568 149.924C703.768 149.724 703.925 149.487 704.032 149.227C704.138 148.966 704.192 148.686 704.189 148.404Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M710.846 150.525C712.017 150.525 712.966 149.576 712.966 148.404C712.966 147.233 712.017 146.283 710.846 146.283C709.674 146.283 708.725 147.233 708.725 148.404C708.725 149.576 709.674 150.525 710.846 150.525Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M748.021 81.3587C748.3 82.7091 748.438 84.0845 748.434 85.4632C748.434 85.6399 748.434 85.797 748.434 85.9738",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M716.836 68.3974C719.371 66.7289 722.246 65.6475 725.252 65.232C728.259 64.8166 731.32 65.0775 734.212 65.9959C737.104 66.9142 739.755 68.4668 741.971 70.5403C744.187 72.6137 745.912 75.1558 747.02 77.9809",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M722.531 71.3628C721.436 71.7904 720.394 72.344 719.428 73.0124",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M743.129 85.8362C743.139 85.7121 743.139 85.5872 743.129 85.4631C743.129 81.4474 741.533 77.5961 738.694 74.7566C735.854 71.9171 732.003 70.3219 727.987 70.3219C727.198 70.3173 726.409 70.383 725.631 70.5182",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M738.222 85.7184V85.4631C738.222 82.7548 737.146 80.1573 735.231 78.2422C733.316 76.3271 730.719 75.2511 728.01 75.2511C725.779 75.2493 723.61 75.9884 721.844 77.3525",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M725.867 80.259C725.216 80.5304 724.623 80.9236 724.119 81.4176",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M733.646 85.6006V85.4632C733.646 83.9683 733.052 82.5347 731.995 81.4777C730.938 80.4207 729.505 79.8269 728.01 79.8269",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M601.144 82.5763C601.003 83.5453 600.931 84.5231 600.928 85.5024C600.928 85.6791 600.928 85.8362 600.928 86.013",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M625.417 65.4516C624.08 65.1744 622.717 65.0362 621.352 65.0392C617.075 65.0375 612.905 66.3785 609.431 68.8731C605.957 71.3677 603.354 74.89 601.988 78.9432",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M632.526 68.3973C631.229 67.5425 629.839 66.8375 628.383 66.296",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M620.135 70.3808C620.528 70.3808 620.94 70.3808 621.352 70.3808C624.426 70.3837 627.426 71.3221 629.954 73.0713",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M606.23 85.8362C606.23 85.7184 606.23 85.6006 606.23 85.4631C606.231 82.4872 607.109 79.5775 608.754 77.0977C610.399 74.6178 612.739 72.6777 615.48 71.5198",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M611.121 85.7184V85.4631C611.121 82.7548 612.197 80.1573 614.112 78.2422C616.027 76.3271 618.625 75.2511 621.333 75.2511C623.565 75.2493 625.733 75.9884 627.5 77.3525",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M615.735 85.6006C615.724 85.5554 615.724 85.5083 615.735 85.4631C615.729 84.3549 616.051 83.2696 616.66 82.344C617.269 81.4183 618.139 80.6936 619.159 80.2611C620.18 79.8287 621.305 79.7077 622.394 79.9135C623.483 80.1192 624.487 80.6426 625.279 81.4176",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M364.914 444.748L351.167 417.549C350.997 417.198 350.695 416.928 350.327 416.799C349.959 416.67 349.554 416.693 349.203 416.861C348.859 417.039 348.596 417.341 348.468 417.706C348.34 418.072 348.357 418.472 348.515 418.825L361.673 446.319C361.401 446.591 361.215 446.938 361.139 447.315C361.062 447.692 361.097 448.083 361.241 448.44L375.145 474.52C375.518 475.247 376.716 475.404 377.816 474.873C378.916 474.343 379.525 473.283 379.171 472.536L366.976 445.612C366.75 445.287 366.436 445.033 366.07 444.88C365.705 444.727 365.304 444.681 364.914 444.748Z",
    fill: "#21343E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M441.053 444.748L454.8 417.549C454.877 417.359 454.993 417.187 455.139 417.044C455.286 416.9 455.46 416.789 455.652 416.716C455.844 416.643 456.048 416.61 456.253 416.62C456.458 416.63 456.658 416.681 456.842 416.772C457.026 416.862 457.189 416.99 457.322 417.147C457.454 417.303 457.553 417.485 457.612 417.681C457.671 417.878 457.689 418.084 457.665 418.288C457.64 418.491 457.574 418.688 457.471 418.865L444.333 446.358C444.601 446.633 444.784 446.98 444.857 447.357C444.93 447.734 444.891 448.124 444.745 448.479L430.841 474.559C430.468 475.286 429.29 475.443 428.17 474.913C427.051 474.383 426.462 473.322 426.815 472.576L439.011 445.652C439.23 445.322 439.539 445.063 439.9 444.903C440.262 444.743 440.662 444.689 441.053 444.748Z",
    fill: "#21343E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M446.295 475.738H359.965L366.426 464.76H439.815L446.295 475.738Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M446.295 475.738H359.965V486.735H446.295V475.738Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M401.638 478.821H368.429C367.095 478.821 366.014 479.902 366.014 481.236V481.256C366.014 482.59 367.095 483.671 368.429 483.671H401.638C402.972 483.671 404.053 482.59 404.053 481.256V481.236C404.053 479.902 402.972 478.821 401.638 478.821Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M421.707 483.082C422.878 483.082 423.828 482.133 423.828 480.961C423.828 479.79 422.878 478.84 421.707 478.84C420.535 478.84 419.586 479.79 419.586 480.961C419.586 482.133 420.535 483.082 421.707 483.082Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M432.629 480.961C432.633 480.536 432.51 480.12 432.276 479.765C432.043 479.41 431.708 479.132 431.316 478.968C430.925 478.803 430.493 478.759 430.075 478.841C429.658 478.923 429.275 479.128 428.975 479.428C428.674 479.729 428.47 480.112 428.388 480.529C428.306 480.946 428.35 481.378 428.514 481.77C428.679 482.162 428.956 482.496 429.311 482.73C429.666 482.963 430.083 483.086 430.508 483.082C431.07 483.082 431.61 482.859 432.008 482.461C432.405 482.063 432.629 481.524 432.629 480.961Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M439.285 483.082C440.456 483.082 441.406 482.133 441.406 480.961C441.406 479.79 440.456 478.84 439.285 478.84C438.114 478.84 437.164 479.79 437.164 480.961C437.164 482.133 438.114 483.082 439.285 483.082Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M466.66 400.306C469.765 402.097 472.345 404.672 474.141 407.775C475.937 410.877 476.885 414.397 476.892 417.981C476.892 418.158 476.892 418.315 476.892 418.492",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M445.275 400.935C448.601 398.754 452.492 397.593 456.469 397.596C458.722 397.587 460.959 397.959 463.087 398.696",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M453.817 403.095C451.703 403.492 449.696 404.328 447.926 405.55",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M471.688 418.393C471.688 418.276 471.688 418.158 471.688 418.02C471.682 414.265 470.283 410.646 467.762 407.863C465.24 405.08 461.776 403.332 458.039 402.958",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M463.832 410.911C462.884 409.926 461.746 409.143 460.487 408.609C459.228 408.076 457.874 407.803 456.506 407.808C454.273 407.81 452.1 408.541 450.32 409.89",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M466.661 418.256C466.661 418.256 466.661 418.099 466.661 418.001C466.652 416.651 466.379 415.317 465.855 414.073",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M455.094 412.502C454.141 412.745 453.268 413.232 452.561 413.916",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M462.085 418.138C462.085 418.138 462.085 418.138 462.085 418.001C462.103 416.754 461.705 415.537 460.955 414.542C460.204 413.546 459.144 412.829 457.941 412.502",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M329.662 414.584C329.464 415.712 329.366 416.855 329.367 418.001C329.367 418.177 329.367 418.334 329.367 418.511",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M341.74 399.226C339.228 400.316 336.959 401.895 335.064 403.87C333.169 405.846 331.687 408.18 330.703 410.734",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M360.968 400.935C357.649 398.754 353.765 397.594 349.794 397.596C348.415 397.592 347.04 397.731 345.689 398.009",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M338.363 408.083C340.808 405.275 344.201 403.464 347.896 402.997C351.59 402.53 355.327 403.438 358.394 405.55",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M334.672 418.393C334.672 418.276 334.672 418.158 334.672 418.02C334.673 415.779 335.17 413.566 336.125 411.54",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M342.488 410.872C344.229 409.096 346.558 408.016 349.039 407.835C351.519 407.655 353.98 408.385 355.96 409.89",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M339.602 418.256C339.602 418.256 339.602 418.099 339.602 418.001C339.597 416.477 339.94 414.973 340.603 413.602",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M346.102 413.739C347.171 412.828 348.539 412.347 349.943 412.386C351.347 412.426 352.686 412.985 353.702 413.955",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M344.176 418.138C344.176 418.138 344.176 418.138 344.176 418.001C344.176 417.075 344.405 416.164 344.843 415.349",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1632 279.137L32.4163 251.938C32.3391 251.748 32.2236 251.576 32.077 251.433C31.9305 251.289 31.7559 251.178 31.5643 251.105C31.3727 251.032 31.1681 250.999 30.9633 251.009C30.7585 251.019 30.5579 251.07 30.3739 251.161C30.19 251.252 30.0268 251.379 29.8943 251.536C29.7618 251.692 29.663 251.874 29.6041 252.071C29.5451 252.267 29.5272 252.473 29.5516 252.677C29.5759 252.881 29.6419 253.077 29.7455 253.254L42.8836 280.748C42.6103 281.023 42.4196 281.37 42.3328 281.748C42.2461 282.126 42.2668 282.521 42.3926 282.888L56.2966 308.968C56.6698 309.695 57.848 309.852 58.9674 309.302C60.0868 308.752 60.676 307.731 60.3028 306.985L48.127 280.06C47.9162 279.741 47.6214 279.486 47.2749 279.323C46.9284 279.16 46.5437 279.096 46.1632 279.137Z",
    fill: "#21343E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M122.281 279.137L136.028 251.938C136.198 251.587 136.5 251.317 136.868 251.188C137.236 251.06 137.64 251.082 137.992 251.251C138.336 251.428 138.599 251.73 138.727 252.096C138.855 252.461 138.838 252.862 138.679 253.215L125.522 280.708C125.822 280.974 126.034 281.326 126.129 281.715C126.223 282.105 126.197 282.514 126.052 282.888L112.148 308.968C111.775 309.695 110.577 309.852 109.477 309.302C108.377 308.752 107.769 307.731 108.122 306.985L120.317 280.06C120.527 279.739 120.821 279.483 121.168 279.32C121.515 279.157 121.901 279.094 122.281 279.137Z",
    fill: "#21343E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M127.543 310.127H41.2129L47.6739 299.129H121.063L127.543 310.127Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M127.526 310.127H41.1953V321.124H127.526V310.127Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8485 318.061H49.6792C49.0368 318.055 48.4224 317.797 47.97 317.34C47.5175 316.884 47.2637 316.268 47.2637 315.625C47.2637 314.985 47.5182 314.37 47.9712 313.917C48.4242 313.464 49.0386 313.21 49.6792 313.21H82.8485C83.4891 313.21 84.1035 313.464 84.5565 313.917C85.0095 314.37 85.264 314.985 85.264 315.625C85.2641 316.268 85.0102 316.884 84.5577 317.34C84.1053 317.797 83.4909 318.055 82.8485 318.061Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M102.957 317.452C104.128 317.452 105.078 316.502 105.078 315.331C105.078 314.16 104.128 313.21 102.957 313.21C101.786 313.21 100.836 314.16 100.836 315.331C100.836 316.502 101.786 317.452 102.957 317.452Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M111.734 317.452C112.906 317.452 113.855 316.502 113.855 315.331C113.855 314.16 112.906 313.21 111.734 313.21C110.563 313.21 109.613 314.16 109.613 315.331C109.613 316.502 110.563 317.452 111.734 317.452Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M122.652 315.331C122.652 314.907 122.526 314.492 122.29 314.14C122.054 313.787 121.719 313.513 121.326 313.351C120.934 313.19 120.503 313.149 120.087 313.233C119.671 313.317 119.29 313.523 118.991 313.824C118.693 314.126 118.49 314.509 118.41 314.925C118.329 315.342 118.375 315.773 118.54 316.164C118.705 316.555 118.982 316.887 119.337 317.12C119.691 317.353 120.107 317.475 120.531 317.471C120.812 317.471 121.089 317.416 121.348 317.308C121.606 317.2 121.841 317.042 122.038 316.843C122.235 316.644 122.391 316.408 122.496 316.149C122.602 315.889 122.655 315.611 122.652 315.331Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M157.002 245.693C157.745 247.848 158.123 250.111 158.121 252.39C158.121 252.567 158.121 252.724 158.121 252.9",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M141.764 232.359C144.889 232.99 147.824 234.341 150.337 236.305C152.849 238.268 154.869 240.79 156.237 243.67",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M126.521 235.324C129.247 233.527 132.366 232.415 135.614 232.084",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M149.086 242.413C146.643 239.618 143.256 237.821 139.572 237.365C135.888 236.908 132.165 237.825 129.113 239.939",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M152.82 252.763C152.83 252.639 152.83 252.514 152.82 252.39C152.823 249.964 152.243 247.573 151.131 245.418",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M135.596 242.414C134.111 242.754 132.721 243.425 131.531 244.377",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M147.909 252.645V252.39C147.91 250.068 147.118 247.815 145.665 246.005C144.211 244.194 142.183 242.934 139.916 242.433",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M142.137 248.914C141.654 248.292 141.044 247.779 140.349 247.409C139.653 247.039 138.887 246.82 138.101 246.766C137.315 246.712 136.527 246.825 135.787 247.097C135.048 247.369 134.374 247.794 133.811 248.344",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M143.333 252.527V252.39C143.336 251.838 143.257 251.288 143.098 250.76",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M27.467 232.28C22.7439 233.119 18.4671 235.595 15.3862 239.272C12.3053 242.949 10.617 247.593 10.6172 252.39C10.6172 252.566 10.6172 252.724 10.6172 252.9",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2137 235.324C39.2782 233.4 35.8966 232.263 32.3945 232.025",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3789 237.72C36.2556 238.127 38.0403 238.88 39.642 239.939",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9199 252.763C15.9199 252.645 15.9199 252.527 15.9199 252.39C15.9199 248.374 17.5152 244.523 20.3547 241.683C23.1942 238.844 27.0455 237.249 31.0612 237.249",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M23.166 245.909C24.8359 243.866 27.2355 242.553 29.8565 242.249C32.4775 241.945 35.114 242.673 37.2075 244.279",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8281 252.645V252.39C20.8274 251.039 21.1014 249.703 21.6333 248.462",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M32.043 246.852C33.1375 247.052 34.1486 247.572 34.9495 248.344",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4258 252.527C25.4258 252.527 25.4258 252.527 25.4258 252.39C25.4303 251.056 25.9057 249.768 26.7681 248.751C27.6304 247.734 28.8243 247.054 30.139 246.832",
    stroke: "#21343E",
    strokeWidth: 0.442342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M495.369 498.204H320.371V618.096H495.369V498.204Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M521.626 671.101H294.135L320.372 618.096H495.37L521.626 671.101Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M484.765 507.689H330.977V608.611H484.765V507.689Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M430.915 548.459L407.918 521.259L384.922 548.459H394.545V591.054H421.292V548.459H430.915Z",
    fill: "url(#paint15_linear_2162_7418)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M400.574 634.887L400.868 628.426H391.638L391.01 634.887H400.574Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M419.683 634.887L419.369 628.426H410.119L410.139 634.887H419.683Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M469.446 641.78H479.344L477.007 634.887H467.463L469.446 641.78Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M391.013 634.887L391.641 628.426H382.392L381.469 634.887H391.013Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M371.904 634.887L373.141 628.426H363.891L362.359 634.887H371.904Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M457.899 634.887L456.347 628.426H447.098L448.354 634.887H457.899Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M467.463 634.887L465.597 628.426H456.348L457.899 634.887H467.463Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M362.359 634.887L363.891 628.426H354.641L352.795 634.887H362.359Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M429.247 634.887L428.619 628.426H419.369L419.683 634.887H429.247Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M477.01 634.887L474.849 628.426H465.6L467.465 634.887H477.01Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M448.356 634.887L447.099 628.426H437.869L438.792 634.887H448.356Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M438.79 634.887L437.867 628.426H428.617L429.246 634.887H438.79Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M410.138 634.887L410.118 628.426H400.869L400.574 634.887H410.138Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M343.25 634.887H333.686L331.055 641.78H340.933L343.25 634.887Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M345.394 628.426H336.164L333.689 634.887H343.253L345.394 628.426Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M352.794 634.887L354.64 628.426H345.391L343.25 634.887H352.794Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M328.226 649.184L325.182 657.138H335.806L338.457 649.184H328.226Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M340.935 641.78H331.056L328.229 649.184H338.46L340.935 641.78Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M338.46 649.184L335.809 657.138H346.433L348.711 649.184H338.46Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M381.468 634.887L382.391 628.426H373.142L371.904 634.887H381.468Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M380.486 641.78L381.468 634.887H371.904L370.588 641.78H380.486Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M370.589 641.78L371.905 634.887H362.361L360.711 641.78H370.589Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M390.364 641.78L391.013 634.887H381.468L380.486 641.78H390.364Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M352.795 634.887H343.251L340.934 641.78H350.831L352.795 634.887Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M471.588 649.184H481.82L479.345 641.78H469.447L471.588 649.184Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M360.708 641.78L362.358 634.887H352.794L350.83 641.78H360.708Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M340.931 641.78L338.457 649.184H348.708L350.829 641.78H340.931Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M449.671 641.78L448.355 634.887H438.791L439.793 641.78H449.671Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M439.794 641.78L438.792 634.887H429.248L429.916 641.78H439.794Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M469.448 641.78L467.464 634.887H457.9L459.57 641.78H469.448Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M410.138 641.78V634.887H400.574L400.24 641.78H410.138Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M429.915 641.78L429.248 634.887H419.684L420.017 641.78H429.915Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M420.017 641.78L419.683 634.887H410.139V641.78H420.017Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M400.241 641.78L400.575 634.887H391.011L390.363 641.78H400.241Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M429.916 641.78L430.623 649.184H440.874L439.794 641.78H429.916Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M439.793 641.78L440.873 649.184H451.105L449.671 641.78H439.793Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M350.832 641.78L348.711 649.184H358.943L360.71 641.78H350.832Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M449.67 641.78L451.103 649.184H461.335L459.568 641.78H449.67Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M410.139 641.78V649.184H420.39L420.017 641.78H410.139Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M459.568 641.78L461.336 649.184H471.587L469.446 641.78H459.568Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M420.018 641.78L420.391 649.184H430.622L429.915 641.78H420.018Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M370.588 641.78L369.174 649.184H379.425L380.486 641.78H370.588Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M360.709 641.78L358.941 649.184H369.173L370.587 641.78H360.709Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M400.242 641.78L399.908 649.184H410.14V641.78H400.242Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M390.363 641.78L389.656 649.184H399.908L400.241 641.78H390.363Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M380.484 641.78L379.424 649.184H389.655L390.362 641.78H380.484Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M459.569 641.78L457.9 634.887H448.355L449.671 641.78H459.569Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M345.392 628.426L347.611 621.808H338.676L336.162 628.426H345.392Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M336.161 628.426H327.619L324.869 634.887H333.687L336.161 628.426Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M338.676 621.808H330.447L327.619 628.426H336.162L338.676 621.808Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M333.687 634.887H324.87L321.924 641.78H331.056L333.687 634.887Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M331.057 641.78H321.925L318.764 649.184H328.229L331.057 641.78Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M328.226 649.184H318.761L315.383 657.138H325.182L328.226 649.184Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M486.572 634.887L489.223 641.78H497.963L495.017 634.887H486.572Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M492.07 649.184H501.124L497.962 641.78H489.223L492.07 649.184Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M495.114 657.138H504.501L501.124 649.184H492.07L495.114 657.138Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M419.369 628.426L419.055 621.808H410.119V628.426H419.369Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M486.572 634.887H495.017L492.267 628.426H484.098L486.572 634.887Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M481.818 649.184H492.069L489.222 641.78H479.344L481.818 649.184Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M354.64 628.426L356.545 621.808H347.61L345.391 628.426H354.64Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M474.85 628.426L477.01 634.887H486.574L484.099 628.426H474.85Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M492.266 628.426L489.457 621.808H481.543L484.096 628.426H492.266Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M484.1 628.426L481.547 621.808H472.631L474.85 628.426H484.1Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M451.105 649.184L452.637 657.138H463.262L461.337 649.184H451.105Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M484.491 657.138H495.116L492.072 649.184H481.82L484.491 657.138Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M474.846 628.426L472.627 621.808H463.691L465.596 628.426H474.846Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M471.588 649.184L473.866 657.138H484.49L481.819 649.184H471.588Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M461.338 649.184L463.262 657.138H473.867L471.589 649.184H461.338Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M479.347 641.78H489.225L486.574 634.887H477.01L479.347 641.78Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M391.64 628.426L392.269 621.808H383.333L382.391 628.426H391.64Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M465.598 628.426L463.693 621.808H454.758L456.349 628.426H465.598Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M382.39 628.426L383.333 621.808H374.397L373.141 628.426H382.39Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M410.121 628.426V621.808H401.185L400.871 628.426H410.121Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M373.14 628.426L374.397 621.808H365.462L363.891 628.426H373.14Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M363.892 628.426L365.463 621.808H356.548L354.643 628.426H363.892Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M400.871 628.426L401.185 621.808H392.269L391.641 628.426H400.871Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M456.35 628.426L454.76 621.808H445.844L447.101 628.426H456.35Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M447.099 628.426L445.842 621.808H436.906L437.869 628.426H447.099Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M428.619 628.426L427.97 621.808H419.055L419.369 628.426H428.619Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M451.106 649.184H440.875H430.624H420.392H410.141H399.909H389.658H379.426H369.175H358.943H348.712L346.434 657.138H357.058H367.663H378.287H388.912H399.536H410.141H420.765H431.389H442.014H452.638L451.106 649.184Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M437.868 628.426L436.906 621.808H427.971L428.619 628.426H437.868Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M521.725 671.1H294.135V674.321H521.725V671.1Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M559.765 498.204H693.307V618.096H559.765C558.922 618.096 558.112 617.761 557.516 617.165C556.919 616.568 556.584 615.759 556.584 614.915V501.405C556.581 500.985 556.662 500.57 556.821 500.181C556.979 499.793 557.213 499.44 557.509 499.143C557.805 498.845 558.156 498.609 558.543 498.448C558.931 498.287 559.346 498.204 559.765 498.204Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M697.9 498.204H560.176V618.096H697.9V498.204Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M690.379 507.689H570.781V608.611H690.379V507.689Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M611.629 548.459L629.461 521.259L647.292 548.459H639.83V591.054H619.091V548.459H611.629Z",
    fill: "url(#paint16_linear_2162_7418)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M560.176 618.096L664.574 648.281H805.322L697.9 618.096H560.176Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M671.663 630.037L658.603 626.325L652.889 626.266L665.909 629.997L671.663 630.037Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M683.036 630.135L669.937 626.443L664.301 626.384L677.36 630.095L683.036 630.135Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M724.316 634.043L729.776 634.082L716.206 630.37L710.766 630.331L724.316 634.043Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M665.909 629.997L652.889 626.266L647.135 626.207L660.116 629.958L665.909 629.997Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M654.306 629.919L641.325 626.168L635.492 626.109L648.434 629.879L654.306 629.919Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M705.305 630.292L692.108 626.639L686.629 626.6L699.787 630.253L705.305 630.292Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M710.764 630.331L697.547 626.698L692.107 626.639L705.304 630.292L710.764 630.331Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M648.433 629.879L635.491 626.109L629.6 626.05L642.502 629.84L648.433 629.879Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M688.651 630.174L675.532 626.482L669.936 626.443L683.034 630.135L688.651 630.174Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M716.205 630.37L702.969 626.757L697.549 626.698L710.765 630.331L716.205 630.37Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M699.786 630.253L686.628 626.6L681.09 626.541L694.248 630.213L699.786 630.253Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M694.249 630.213L681.091 626.541L675.533 626.482L688.652 630.174L694.249 630.213Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M677.36 630.096L664.301 626.384L658.605 626.325L671.665 630.037L677.36 630.096Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M636.55 629.781L630.541 629.742L643.738 633.65L649.767 633.689L636.55 629.781Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M623.667 625.991L617.697 625.932L630.541 629.742L636.55 629.781L623.667 625.991Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M642.503 629.84L629.601 626.05L623.67 625.991L636.553 629.781L642.503 629.84Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M657.27 637.656L671.193 641.78H677.281L663.338 637.676L657.27 637.656Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M649.767 633.689L643.738 633.65L657.269 637.656L663.337 637.676L649.767 633.689Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M663.338 637.676L677.281 641.78H683.33L669.347 637.696L663.338 637.676Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M660.116 629.958L647.135 626.207L641.322 626.168L654.303 629.919L660.116 629.958Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M673.452 633.807L660.118 629.958L654.305 629.919L667.6 633.768L673.452 633.807Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M667.599 633.768L654.304 629.919L648.432 629.88L661.707 633.748L667.599 633.768Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M679.265 633.827L665.91 629.997L660.117 629.958L673.452 633.807L679.265 633.827Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M642.499 629.84L636.549 629.781L649.765 633.689L655.755 633.709L642.499 629.84Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M738.218 637.872L743.678 637.892L729.774 634.082L724.314 634.043L738.218 637.872Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M661.708 633.748L648.433 629.879L642.502 629.84L655.758 633.709L661.708 633.748Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M649.768 633.689L663.338 637.676L669.347 637.696L655.757 633.709L649.768 633.689Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M713.297 634.004L699.786 630.253L694.248 630.213L707.72 633.964L713.297 634.004Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M707.721 633.964L694.249 630.213L688.652 630.174L702.124 633.945L707.721 633.964Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M724.315 634.043L710.764 630.331L705.305 630.292L718.836 634.023L724.315 634.043Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M690.772 633.886L677.359 630.095L671.664 630.036L685.038 633.846L690.772 633.886Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M702.122 633.945L688.65 630.174L683.033 630.135L696.466 633.905L702.122 633.945Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M696.468 633.905L683.035 630.135L677.359 630.095L690.772 633.886L696.468 633.905Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M685.04 633.847L671.666 630.037L665.912 629.997L679.266 633.827L685.04 633.847Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M702.125 633.945L715.931 637.813L721.567 637.833L707.722 633.964L702.125 633.945Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M707.721 633.964L721.566 637.833L727.143 637.853L713.298 634.004L707.721 633.964Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M655.758 633.709L669.348 637.696L675.337 637.715L661.708 633.748L655.758 633.709Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M713.297 634.004L727.142 637.853H732.7L718.835 634.023L713.297 634.004Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M690.771 633.886L704.538 637.774L710.253 637.794L696.467 633.905L690.771 633.886Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M718.838 634.023L732.703 637.853L738.221 637.872L724.317 634.043L718.838 634.023Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M696.467 633.905L710.253 637.794L715.928 637.813L702.123 633.945L696.467 633.905Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M667.6 633.768L681.248 637.735H687.14L673.452 633.807L667.6 633.768Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M661.709 633.748L675.338 637.715L681.249 637.735L667.601 633.768L661.709 633.748Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M685.037 633.846L698.784 637.774H704.538L690.771 633.886L685.037 633.846Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M679.264 633.827L692.991 637.754L698.784 637.774L685.037 633.846L679.264 633.827Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M673.451 633.807L687.139 637.735L692.991 637.755L679.264 633.827L673.451 633.807Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M718.834 634.023L705.304 630.292L699.785 630.253L713.296 634.004L718.834 634.023Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M623.668 625.991L609.941 621.946L604.01 621.887L617.698 625.932L623.668 625.991Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M617.698 625.932L612.141 625.873L624.965 629.703L630.542 629.742L617.698 625.932Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M604.011 621.887L598.492 621.808L612.141 625.873L617.699 625.932L604.011 621.887Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M630.542 629.742L624.965 629.703L638.123 633.63L643.739 633.65L630.542 629.742Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M643.74 633.65L638.123 633.63L651.634 637.656H657.271L643.74 633.65Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M657.269 637.656H651.633L665.517 641.78H671.193L657.269 637.656Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M721.605 630.41L735.195 634.102L739.948 634.141L726.338 630.449L721.605 630.41Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M749.117 637.892L753.889 637.912L739.946 634.141L735.193 634.102L749.117 637.892Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M763.414 641.78H768.186L753.889 637.912L749.117 637.892L763.414 641.78Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M669.935 626.443L655.952 622.495L650.336 622.437L664.299 626.384L669.935 626.443Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M721.606 630.41L726.339 630.449L713.063 626.855L708.33 626.796L721.606 630.41Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M743.677 637.892H749.117L735.194 634.102L729.773 634.082L743.677 637.892Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M629.598 626.05L615.831 622.024L609.939 621.946L623.667 625.991L629.598 626.05Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M702.969 626.757L716.205 630.37L721.606 630.41L708.33 626.796L702.969 626.757Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M713.062 626.855L698.883 623.006L694.189 622.947L708.329 626.796L713.062 626.855Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M708.329 626.796L694.189 622.947L688.828 622.888L702.968 626.757L708.329 626.796Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M727.143 637.853L741.361 641.78H746.938L732.7 637.853H727.143Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M757.955 641.78H763.414L749.118 637.892H743.678L757.955 641.78Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M702.968 626.757L688.828 622.888L683.447 622.829L697.548 626.698L702.968 626.757Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M738.219 637.872L752.457 641.78H757.955L743.678 637.892L738.219 637.872Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M732.701 637.853L746.939 641.78H752.457L738.22 637.872L732.701 637.853Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M729.773 634.082L735.193 634.102L721.604 630.41L716.203 630.37L729.773 634.082Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M652.89 626.266L639.006 622.299L633.271 622.221L647.136 626.207L652.89 626.266Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M697.546 626.698L683.446 622.829L678.025 622.751L692.106 626.639L697.546 626.698Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M647.135 626.207L633.27 622.221L627.496 622.162L641.322 626.168L647.135 626.207Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M664.3 626.384L650.337 622.437L644.701 622.358L658.605 626.325L664.3 626.384Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M641.324 626.168L627.499 622.162L621.686 622.083L635.491 626.109L641.324 626.168Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M635.49 626.109L621.684 622.083L615.832 622.024L629.599 626.05L635.49 626.109Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M658.605 626.325L644.701 622.358L639.006 622.299L652.89 626.266L658.605 626.325Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M692.109 626.639L678.028 622.751L672.568 622.692L686.629 626.6L692.109 626.639Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M686.628 626.6L672.567 622.692L667.068 622.633L681.09 626.541L686.628 626.6Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M675.533 626.482L661.53 622.554L655.953 622.495L669.936 626.443L675.533 626.482Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M727.144 637.853L721.566 637.833L715.93 637.813L710.255 637.794L704.54 637.774H698.786L692.992 637.754L687.14 637.735H681.249L675.337 637.715L669.348 637.696L683.33 641.78H689.32H695.29H701.201H707.053H712.886H718.66H724.394H730.089H735.745H741.362L727.144 637.853Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M681.091 626.541L667.069 622.633L661.531 622.554L675.533 626.482L681.091 626.541Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M560.176 618.096V622.103L664.534 653.426L664.574 648.281L560.176 618.096Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M805.323 648.281H664.574V653.406H805.323V648.281Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M250.813 618.096H117.271L117.271 498.204H250.813C251.656 498.204 252.466 498.539 253.062 499.136C253.659 499.732 253.994 500.542 253.994 501.385L253.994 614.895C253.997 615.315 253.916 615.731 253.758 616.119C253.599 616.507 253.365 616.86 253.069 617.158C252.774 617.455 252.422 617.691 252.035 617.852C251.647 618.014 251.232 618.096 250.813 618.096Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M112.676 618.096H250.4L250.4 498.204H112.676L112.676 618.096Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M120.199 608.611H239.797V507.689H120.199L120.199 608.611Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M191.466 548.459L173.634 521.259L155.803 548.459H163.265V591.054H184.004V548.459H191.466Z",
    fill: "url(#paint17_linear_2162_7418)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M250.4 618.096L146.003 648.281H5.25391L112.676 618.096H250.4Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M138.914 630.037L151.974 626.325L157.688 626.266L144.668 629.997L138.914 630.037Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M127.543 630.135L140.642 626.443L146.278 626.384L133.218 630.095L127.543 630.135Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2622 634.043L80.8027 634.082L94.3729 630.37L99.8127 630.331L86.2622 634.043Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M144.668 629.997L157.688 626.266L163.442 626.207L150.461 629.958L144.668 629.997Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M156.275 629.919L169.256 626.168L175.089 626.109L162.147 629.879L156.275 629.919Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M105.271 630.292L118.469 626.639L123.948 626.6L110.79 630.253L105.271 630.292Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8145 630.331L113.031 626.698L118.471 626.639L105.274 630.292L99.8145 630.331Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M162.146 629.879L175.088 626.109L180.98 626.05L168.077 629.84L162.146 629.879Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M121.926 630.174L135.044 626.482L140.641 626.443L127.542 630.135L121.926 630.174Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M94.373 630.37L107.609 626.757L113.03 626.698L99.8129 630.331L94.373 630.37Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M110.791 630.253L123.949 626.6L129.487 626.541L116.329 630.213L110.791 630.253Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M116.328 630.213L129.486 626.541L135.044 626.482L121.925 630.174L116.328 630.213Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M133.219 630.096L146.278 626.384L151.973 626.325L138.914 630.037L133.219 630.096Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M174.025 629.781L180.035 629.742L166.838 633.65L160.809 633.689L174.025 629.781Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M186.91 625.991L192.88 625.932L180.037 629.742L174.027 629.781L186.91 625.991Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M168.076 629.84L180.979 626.05L186.909 625.991L174.027 629.781L168.076 629.84Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M153.308 637.656L139.385 641.78H133.297L147.24 637.676L153.308 637.656Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M160.81 633.689L166.839 633.65L153.309 637.656L147.24 637.676L160.81 633.689Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M147.238 637.676L133.295 641.78H127.246L141.209 637.696L147.238 637.676Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M150.459 629.958L163.44 626.207L169.253 626.168L156.272 629.919L150.459 629.958Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M137.125 633.807L150.459 629.958L156.272 629.919L142.977 633.768L137.125 633.807Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M142.979 633.768L156.274 629.919L162.146 629.88L148.87 633.748L142.979 633.768Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M131.312 633.827L144.667 629.997L150.46 629.958L137.125 633.807L131.312 633.827Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M168.076 629.84L174.027 629.781L160.81 633.689L154.82 633.709L168.076 629.84Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3579 637.872L66.8984 637.892L80.8024 634.082L86.2619 634.043L72.3579 637.872Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M148.871 633.748L162.147 629.879L168.077 629.84L154.822 633.709L148.871 633.748Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M160.81 633.689L147.24 637.676L141.211 637.696L154.82 633.709L160.81 633.689Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2812 634.004L110.792 630.253L116.331 630.213L102.859 633.964L97.2812 634.004Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M102.857 633.964L116.329 630.213L121.926 630.174L108.454 633.945L102.857 633.964Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2617 634.043L99.8122 630.331L105.272 630.292L91.7408 634.023L86.2617 634.043Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M119.805 633.886L133.218 630.095L138.913 630.036L125.539 633.846L119.805 633.886Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M108.453 633.945L121.925 630.174L127.542 630.135L114.109 633.905L108.453 633.945Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M114.109 633.905L127.542 630.135L133.218 630.095L119.805 633.886L114.109 633.905Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M125.539 633.847L138.913 630.037L144.667 629.997L131.313 633.827L125.539 633.847Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M108.454 633.945L94.648 637.813L89.0117 637.833L102.857 633.964L108.454 633.945Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M102.858 633.964L89.0129 637.833L83.4355 637.853L97.2806 634.004L102.858 633.964Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M154.82 633.709L141.21 637.696L135.24 637.715L148.869 633.748L154.82 633.709Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2817 634.004L83.4366 637.853H77.8789L91.7436 634.023L97.2817 634.004Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M119.804 633.886L106.037 637.774L100.322 637.794L114.108 633.905L119.804 633.886Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7425 634.023L77.8778 637.853L72.3594 637.872L86.2634 634.043L91.7425 634.023Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M114.11 633.905L100.324 637.794L94.6484 637.813L108.454 633.945L114.11 633.905Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M142.98 633.768L129.331 637.735H123.439L137.127 633.807L142.98 633.768Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M148.87 633.748L135.241 637.715L129.33 637.735L142.979 633.768L148.87 633.748Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M125.54 633.846L111.793 637.774H106.039L119.806 633.886L125.54 633.846Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M131.314 633.827L117.586 637.754L111.793 637.774L125.54 633.846L131.314 633.827Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M137.126 633.807L123.438 637.735L117.586 637.755L131.313 633.827L137.126 633.807Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7422 634.023L105.273 630.292L110.791 630.253L97.2802 634.004L91.7422 634.023Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M186.91 625.991L200.637 621.946L206.568 621.887L192.88 625.932L186.91 625.991Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M192.881 625.932L198.438 625.873L185.614 629.703L180.037 629.742L192.881 625.932Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M206.567 621.887L212.085 621.808L198.437 625.873L192.879 625.932L206.567 621.887Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M180.035 629.742L185.612 629.703L172.454 633.63L166.838 633.65L180.035 629.742Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M166.839 633.65L172.456 633.63L158.945 637.656H153.309L166.839 633.65Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M153.306 637.656H158.943L145.058 641.78H139.383L153.306 637.656Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9732 630.41L75.3834 634.102L70.6309 634.141L84.2403 630.449L88.9732 630.41Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4596 637.892L56.6875 637.912L70.6308 634.141L75.3833 634.102L61.4596 637.892Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1608 641.78H42.3887L56.6854 637.912L61.4576 637.892L47.1608 641.78Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M140.643 626.443L154.625 622.495L160.242 622.437L146.279 626.384L140.643 626.443Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9711 630.41L84.2383 630.449L97.5139 626.855L102.227 626.796L88.9711 630.41Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8988 637.892H61.459L75.3826 634.102L80.8028 634.082L66.8988 637.892Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M180.979 626.05L194.745 622.024L200.637 621.946L186.909 625.991L180.979 626.05Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M107.61 626.757L94.3732 630.37L88.9727 630.41L102.229 626.796L107.61 626.757Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5156 626.855L111.695 623.006L116.388 622.947L102.229 626.796L97.5156 626.855Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M102.229 626.796L116.388 622.947L121.749 622.888L107.609 626.757L102.229 626.796Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4342 637.853L69.216 641.78H63.6387L77.8765 637.853H83.4342Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6216 641.78H47.1621L61.4589 637.892H66.8987L52.6216 641.78Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M107.609 626.757L121.749 622.888L127.13 622.829L113.03 626.698L107.609 626.757Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3597 637.872L58.1218 641.78H52.623L66.9002 637.892L72.3597 637.872Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8773 637.853L63.6395 641.78H58.1211L72.359 637.872L77.8773 637.853Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M80.803 634.082L75.3828 634.102L88.9726 630.41L94.3732 630.37L80.803 634.082Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M157.688 626.266L171.572 622.299L177.306 622.221L163.442 626.207L157.688 626.266Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M113.029 626.698L127.13 622.829L132.55 622.751L118.469 626.639L113.029 626.698Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M163.441 626.207L177.306 622.221L183.08 622.162L169.254 626.168L163.441 626.207Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M146.279 626.384L160.242 622.437L165.878 622.358L151.974 626.325L146.279 626.384Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M169.254 626.168L183.079 622.162L188.892 622.083L175.087 626.109L169.254 626.168Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M175.088 626.109L188.894 622.083L194.746 622.024L180.979 626.05L175.088 626.109Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M151.973 626.325L165.877 622.358L171.572 622.299L157.687 626.266L151.973 626.325Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M118.469 626.639L132.549 622.751L138.009 622.692L123.948 626.6L118.469 626.639Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M123.947 626.6L138.008 622.692L143.507 622.633L129.485 626.541L123.947 626.6Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M135.045 626.482L149.047 622.554L154.624 622.495L140.642 626.443L135.045 626.482Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M83.435 637.853L89.0123 637.833L94.6486 637.813L100.324 637.794L106.039 637.774H111.793L117.586 637.754L123.438 637.735H129.33L135.241 637.715L141.211 637.696L127.248 641.78H121.259H115.289H109.397H103.525H97.6925H91.9188H86.1844H80.4893H74.8334H69.2168L83.435 637.853Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M129.486 626.541L143.508 622.633L149.046 622.554L135.044 626.482L129.486 626.541Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.221171,
    strokeMiterlimit: 10
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M250.402 618.096V622.103L146.024 653.426L146.004 648.281L250.402 618.096Z",
    fill: "#41525B",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25531 653.426H146.004V648.3H5.25531V653.426Z",
    fill: "#21343E",
    stroke: "#21343E",
    strokeWidth: 0.884684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_7418",
    x1: 586.741,
    y1: 611.201,
    x2: 597.425,
    y2: 681.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_7418",
    x1: 72.9617,
    y1: 611.201,
    x2: 83.6461,
    y2: 681.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2162_7418",
    x1: 452.149,
    y1: 301.979,
    x2: 613.454,
    y2: 457.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2162_7418",
    x1: 581.542,
    y1: 130.634,
    x2: 802.655,
    y2: 216.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2162_7418",
    x1: 173.889,
    y1: -28.0405,
    x2: 374.774,
    y2: 17.1791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2162_7418",
    x1: 339.108,
    y1: 18.3672,
    x2: 347.833,
    y2: 66.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2162_7418",
    x1: 510.867,
    y1: 25.3903,
    x2: 523.296,
    y2: 35.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2162_7418",
    x1: 339.108,
    y1: 89.7529,
    x2: 347.833,
    y2: 138.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2162_7418",
    x1: 485.16,
    y1: 96.7956,
    x2: 497.589,
    y2: 107.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2162_7418",
    x1: 339.108,
    y1: 161.158,
    x2: 347.833,
    y2: 209.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2162_7418",
    x1: 510.867,
    y1: 168.181,
    x2: 523.296,
    y2: 178.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2162_7418",
    x1: 339.108,
    y1: 232.544,
    x2: 347.833,
    y2: 280.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2162_7418",
    x1: 485.16,
    y1: 239.587,
    x2: 497.589,
    y2: 250.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2162_7418",
    x1: 339.108,
    y1: 303.949,
    x2: 347.833,
    y2: 352.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2162_7418",
    x1: 510.867,
    y1: 310.972,
    x2: 523.296,
    y2: 321.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2162_7418",
    x1: 396.569,
    y1: 512.071,
    x2: 453.789,
    y2: 544.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2162_7418",
    x1: 620.66,
    y1: 512.071,
    x2: 669.73,
    y2: 533.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2162_7418",
    x1: 164.834,
    y1: 512.071,
    x2: 213.904,
    y2: 533.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/Image 3.7417122710025b3157125822db4d4a2e.svg";
export { ForwardRef as ReactComponent };